import { useState } from 'react'
import { Send } from 'lucide-react'

type Props = {
  onSend: (body: string) => Promise<void>
  disabled?: boolean
}

export function MessageInput({ onSend, disabled }: Props) {
  const [body, setBody] = useState('')
  const [sending, setSending] = useState(false)

  async function handleSend() {
    const trimmed = body.trim()
    if (!trimmed || sending || disabled) return
    setSending(true)
    try {
      await onSend(trimmed)
      setBody('')
    } catch {
      // Toast handled by parent
    } finally {
      setSending(false)
    }
  }

  return (
    <div className="bg-background px-3 py-2 safe-area-bottom">
      <div className="flex items-end gap-2">
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault()
              handleSend()
            }
          }}
          placeholder={
            disabled ? 'Cannot send messages' : 'Type a message...'
          }
          disabled={disabled}
          rows={1}
          className="flex-1 resize-none bg-muted rounded-2xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 disabled:opacity-50 max-h-24"
          style={{ minHeight: '40px' }}
        />
        <button
          onClick={handleSend}
          disabled={!body.trim() || sending || disabled}
          className="h-10 w-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center disabled:opacity-50"
          aria-label="Send"
        >
          <Send className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
